import styled from "styled-components";

export const SidebarControlContent = styled.div<{ $popoverWidth?: string }>`
    width: ${({ $popoverWidth }) => $popoverWidth ?? "400px"};
    padding: 1rem 1rem 1.5rem 1rem;
`;
